import { render, staticRenderFns } from "./Superflows.vue?vue&type=template&id=2c3a3ddb&scoped=true&"
import script from "./Superflows.vue?vue&type=script&lang=js&"
export * from "./Superflows.vue?vue&type=script&lang=js&"
import style0 from "./Superflows.vue?vue&type=style&index=0&id=2c3a3ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a3ddb",
  null
  
)

export default component.exports